import React from "react";
import Loadable from "react-loadable";
import { Route, Switch, withRouter } from "react-router-dom";

import { connect } from "react-redux";

import "../styles/landing-page.css";
import { AsynLoader } from "./Loader/AsynLoader";

const LandingPage = props => {
  return (
    <div className="t-container" id="content">
      <div className="t-row">
        {props.count > 0 && (
          <div className="offset-sm-1 t-col-10 landing__page_activity-count">
            {`${props.count} ${props.count > 1 ? "activities" : "activity"} found`}
          </div>
        )}
      </div>
      <div>
        <Switch>
          <Route
            exact
            path={"/country/:countryName/activities/:countryId"}
            component={AsynActivityList}
          />
          <Route
            exact
            path={"/state/:stateName/activities/:stateId"}
            component={AsynActivityList}
          />
          <Route
            exact
            path={"/activities-in-:destination/:locationId"}
            component={AsynActivityList}
          />
          <Route exact path={"/activity/:type"} component={AsynActivityList} />
          <Route exact path={"/activity"} component={AsynActivityList} />
        </Switch>
      </div>
    </div>
  );
};

const AsynActivityList = Loadable({
  loader: () => import("./ActivityList"),
  render(loaded, props) {
    let Component = loaded.default;
    return <Component {...props} />;
  },
  loading: AsynLoader,
  delay: 0
});

const mapStateToProps = state => {
  return {
    count: state.activities.count
  };
};
export default withRouter(connect(mapStateToProps)(LandingPage));
